export type PropertyAlertSegment = "residential" | "commercial";

/** Corpo enviado ao POST /api/client/tenant/property-alerts */
export type PropertyAlertRequestBody = {
  max_rent: number;
  min_rooms: number;
  segment: PropertyAlertSegment;
  notify_email: boolean;
  notify_whatsapp: boolean;
  whatsapp_opt_in: boolean;
  city?: string;
  neighborhood?: string;
  property_type_id?: number;
};

export function buildPropertyAlertRequestBody(params: {
  cityFromUrl: string;
  neighborhood: string;
  maxRent: string;
  minRooms: string;
  propertyTypeId: string;
  propertyKind: PropertyAlertSegment;
  notifyEmail: boolean;
  notifyWhatsapp: boolean;
  whatsappOptIn: boolean;
}): PropertyAlertRequestBody {
  const body: PropertyAlertRequestBody = {
    max_rent: Number(params.maxRent),
    min_rooms: Number(params.minRooms),
    segment: params.propertyKind,
    notify_email: params.notifyEmail,
    notify_whatsapp: params.notifyWhatsapp,
    whatsapp_opt_in: params.whatsappOptIn,
  };

  const cityTrim = params.cityFromUrl.trim();
  if (cityTrim) body.city = cityTrim;

  const neighborhoodTrim = params.neighborhood.trim();
  if (neighborhoodTrim) body.neighborhood = neighborhoodTrim;

  if (params.propertyTypeId) {
    const id = Number(params.propertyTypeId);
    if (!Number.isNaN(id)) body.property_type_id = id;
  }

  return body;
}
